export class SecurityUserTwoFactorAuthConfigModel {
    constructor() {
        this.securityKey = "";
        this.qrCode = "";
        this.email = "";
    }
}
export default class SecurityUserTwoFactorAuthConfig extends SecurityUserTwoFactorAuthConfigModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
